import React, { useEffect, useRef, useState } from "react";

import pic from "../../../assets/images/profile-dummy.png";
import {
  Avatar,
  Button,
  CopyToClipboard,
  DualIcon,
  SmartTooltip,
  LogoLoader,
  Backdrop,
  showToast,
  TableAdv,
  FormFieldSet,
  InfoCardNewAdv,
  CollapsibleWrapper,
  FullScreenWrapper,
} from "../../../components";

import { dateFormator, mapTableRows } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../hooks";
import {
  getAllApplicantsDataStart,
  getCareerBuilderApplicantsDataStart,
} from "../../../redux/slices/internalDbES/internalDbESlice";
import { useLoginUser } from "../../../hooks/useLoginUser";
import { getCandidateResumeFromDB } from "../../../redux/slices/internalDbES/internalDbESApi";
import DetailsDrawer from "./Modals/DetailsDrawer";

import { getMonsterApplicantsDataStart } from "../../../redux/slices/internalDbES/internalDbESlice";
import CareerBuilderFiltersModal from "./CareerBuilderFiltersModal";
import TableGridToggleView from "./SearchResults/TableGridToggleView";
import TableGridMonsterToggleView from "./SearchResults/TableGridMonsterToggleView";
import MonsterFiltersModal from "./MonsterFiltersModal";
import {
  formatPhoneNumberLength,
  formatWords2,
} from "../../../utils/stringUtils";
import { fetchBulkResumesDataStart } from "../../../redux/slices/internalDbES/internalDbESlice";

import {
  CreateListModal,
  MailMergeModal,
  MigrateProfilesModal,
} from "../CommonJobBoards/Modals/MonsterModals/MonsterModals";
import AddNoteModal from "../ConfirmedStart/Confirmed/modals/AddNoteModal";
import {
  careerbuilderOptions,
  monsterSearchOptions,
} from "../../../assets/data/enumData";
import { fetchCBBulkResumesDataStart } from "../../../redux/slices/internalDbES/internalDbESlice";
import { setcareerBuilderAccessidStart } from "../../../redux/slices/internalDbES/internalDbESlice";
import { setMonsterAccessidStart } from "../../../redux/slices/internalDbES/internalDbESlice";
import { convertFromUTC } from "../../../utils/dateUtils";
import {
  fetchAllNotes,
  jobsTableFilter,
} from "../../../redux/slices/bdmjobs/bdmjobsApi";
import AiCallModel from "./Modals/AiCallModel";
import {
  getAllIntegrationAccess,
  getAllIntegrations,
} from "../../../redux/slices/setting/settingApi";

const Gender = {
  1: "MALE",
  2: "FEMALE",
  3: "WISH NOT TO SPECIFY",
  4: "OTHER",
};

const getJobBoardsName = {
  1: "Internal DB",
  2: "Career Builder",
  3: "Monster",
};

const actionMap = {
  1: getAllApplicantsDataStart,
  2: getCareerBuilderApplicantsDataStart,
  3: getMonsterApplicantsDataStart,
};
const SearchResults = ({
  source,
  query,
  loading = false,
  setSearchApplicant,
  setShowButtons,
}) => {
  //  console.log("query", query);

  if (source === 3) {
    setShowButtons(false);
  }
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const [searchQuery, setSearchQuery] = useState(query);
  const [tableViewMode, setTableViewMode] = useState("list");
  const [tableRenderKey, setTableRenderKey] = useState(0);
  const dispatch = useDispatch();
  const { loginUserUiid } = useLoginUser();
  const toggleDrawer = () => {
    setDetailsDrawer((prev) => !prev);
  };
  const firstRender = useRef(true);
  // console.log("searchQuery", searchQuery);

  // This is state is for modal which opens after clicking on Create list Button
  const [showCreateListModal, SetShowCreateListModal] = useState(false);

  // This is state is for modal which opens after clicking on Mail Merge Button
  const [mailMergeModalOpen, setMailMergeModalOpen] = useState(false);
  const [migrateProfilesModalOpen, setMigrateProfilesModalOpen] =
    useState(false);
  const [noResCandidates, setNoResCandidates] = useState(0);
  const [selectMigratedProfiles, setSelectedMigratedProfiles] = useState([]);
  const [defaultExistingCandidates, setDefaultExistingCandidates] = useState(
    [],
  );
  const [hoveredNotes, setHoveredNotes] = useState([]);
  // This state is fro handling grid-view data
  const [selected, setSelected] = useState([]);

  const { accessData } = useSelector((state) => state.internalDbES);

  // Redux States
  const {
    totalApplicantsData: totalApplicants,
    totalApplicantsCount,
    totalRecords,
    careerBuilder,
  } = useSelector((state) => state.internalDbES);
  const {
    total,
    tableResponse,
    fullResponse,
    existingCandidates: existingCandidatesCB,
  } = careerBuilder;

  const {
    total: monsterTotal,
    tableResponse: monsterTableResponse,
    fullResponse: monsterFullResponse,
    existingCandidates: matchingCandidatesMonster,
  } = useSelector((state) => state.internalDbES.monster);
  // console.log("matchingCandidatesMonster",matchingCandidatesMonster);
  // Internal DB
  const [currentApplicantId, setCurrentApplicantId] = useState(null);
  const currentApplicantFullDetails =
    Array.isArray(totalApplicants) &&
    totalApplicants?.find(
      (applicant) => applicant?.uiid === currentApplicantId,
    );

  // Career Builder
  const [careerBuilderCurrentApplicantId, setCareerBuilderCurrentApplicantId] =
    useState(null);
  const careerBuilderCurrentApplicantIdFullDetails = fullResponse?.find(
    (applicant) => applicant?.applicantId == careerBuilderCurrentApplicantId,
  );
  const [careerBuilderExisting, setCareerBuilderExisting] = useState(null);
  const [careerBuilderSort, setCareerBuilderSort] = useState("");
  const { user } = useSelector((state) => state.auth);
  // Monster
  const [monsterExisting, setMonsterExisting] = useState(null);
  const [monsterSort, setMonsterSort] = useState(monsterSearchOptions[0].value);
  const [monsterClassicApplicantId, setMonsterClassicApplicantId] =
    useState(null);
  const [isAiCallModalOpen, setIsAiCallModalOpen] = useState(false);
  const monsterClassicApplicantIdFullDetails = monsterFullResponse?.find(
    (applicant) => applicant?.applicantId == monsterClassicApplicantId,
  );
  const [mailMergeCandidates, setMailMergeCandidates] = useState([]);
  const [hasAiCallAccess, setHasAiCallAccess] = useState(false);

  const getHoveredNotes = async (notes) => {
    setHoveredNotes([]);
    try {
      const res = await fetchAllNotes({
        coll: "Note",
        pg: 1,
        lim: 2,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: notes } },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
      });

      if (res?.data) {
        setHoveredNotes(res.data.data || []);
      } else {
        setHoveredNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
    }
  };

  const handleDelete = (applicantId) => {
    // Update selected state
    setSelected((prev) => prev.filter((s) => s !== applicantId));
    setMailMergeCandidates((prev) =>
      prev.filter((candidate) => candidate.applicantId !== applicantId),
    );
    if (source === 2) {
      // For Career Builder - need to find the resumeId to match
      const resumeId = (existingCandidatesCB || []).find(
        (c) => c.uiid === applicantId,
      )?.resumeIds?.[0]?.id;
      const tableApplicantId = (tableResponse || []).find(
        (row) => row.resumeId === resumeId,
      )?.applicantId;
      const uiidToRemove = (tableResponse || []).find(
        (row) => row.applicantId === tableApplicantId,
      )?.uiid;
      //  get all applicantIds with same uiid
      const fallbackUiidMatch = (existingCandidatesCB || []).find(
        (c) => c.uiid === applicantId,
      )?.uiid;
      //  get all applicantIds with same uiid
      const targetUiid = uiidToRemove ?? fallbackUiidMatch;
      const applicantIdsByUiid = (existingCandidatesCB || [])
        .filter((row) => row.uiid === targetUiid)
        .flatMap((row) => row?.resumeIds?.map((r) => r.id) || []);
      setDefaultExistingCandidates((prev) => {
        const idsToRemove = new Set(applicantIdsByUiid || []);
        const updated = prev.filter((id) => !idsToRemove.has(id));
        setTableRenderKey((prev) => prev + 1);
        return updated;
      });
    }
    setDefaultExistingCandidates((prev) => {
      const updated = prev.filter((s) => {
        if (source === 1) {
          const candidate = (totalApplicants || []).find(
            (item) =>
              item?.mongoId == applicantId ||
              item?.uiid == applicantId ||
              item?._id == applicantId,
          );
          const tableId =
            candidate?.mongoId || candidate?.uiid || candidate?._id;
          // Remove if it matches any of the possible IDs
          return s !== tableId && s !== applicantId;
        }
        if (source === 3) {
          // For Monster - similar logic
          const resumeId = (matchingCandidatesMonster || [])
            .find((c) => c.uiid === applicantId)
            ?.resumeIds?.slice(-1)?.[0]?.id;
          const tableApplicantId = (monsterTableResponse || []).find(
            (row) => row.resumeId == resumeId,
          )?.applicantId;

          return s != tableApplicantId;
        }

        return true;
      });

      return updated;
    });

    setMailMergeCandidates((prev) =>
      prev.filter((candidate) => candidate.applicantId !== applicantId),
    );
    setSelectedMigratedProfiles([]); //for checkbox
  };

  //////for checkbox
  const toggleMigratedCheckbox = (selected, tableData, migratedCandidates) => {
    const migratedIdsInTable = (tableData || [])
      .filter((row) =>
        (migratedCandidates || []).some((c) =>
          c?.resumeIds?.some((r) => r.id === row.resumeId),
        ),
      )
      .map((row) => row.applicantId);

    const isAllMigratedSelected =
      selected.length > 0 &&
      selected.length === migratedIdsInTable.length &&
      selected.every((id) => migratedIdsInTable.includes(id));

    setSelectedMigratedProfiles(isAllMigratedSelected ? ["1"] : []);
  };
  ///////for checkbox

  const handleSelectionChange = (selected) => {
    setSelected(selected);
    setDefaultExistingCandidates(selected);
    if (source === 1) {
      const filterData =
        Array.isArray(selected) && selected.length > 0
          ? (totalApplicants || []).filter((item) =>
              selected.includes(item?.mongoId ?? item?.uiid),
            )
          : [];
      const mailMergeData = filterData.map((item) => ({
        applicantId: item.uiid,
        name: `${item.firstName ?? ""} ${item.lastName ?? ""}`.trim(),
        email: item.email?.primary?.email ?? item.email?.primary ?? "",
        jobTitle: item.jobTitle ?? "-",
        experience: item.exp?.year ? item.exp.year : "-",
        payrate: item.salaryInfo?.payRate?.currency ?? "N/A",
        noticePeriod: item.noticePeriod ?? "N/A",
      }));
      setMailMergeCandidates(mailMergeData);
    } else if (source === 2) {
      const updatedCandidatesIds = (tableResponse || [])
        .filter((doc) => selected.includes(doc?.applicantId))
        .map((data) => data?.resumeId)
        .filter(Boolean);
      const targetSet = new Set(updatedCandidatesIds);
      const foundItems = (existingCandidatesCB || []).filter((item) =>
        item?.resumeIds?.some((resume) => targetSet.has(resume?.id)),
      );
      const mailMergeData = foundItems.map((item) => ({
        applicantId: item.uiid,
        name: `${item.firstName ?? ""} ${item.lastName ?? ""}`.trim(),
        email: item.email?.primary?.email ?? item.email?.primary ?? "",
        jobTitle: item.jobTitle ?? "-",
        experience: item.exp?.year ? item.exp.year : "-",
        payrate: item.salaryInfo?.payRate?.currency ?? "N/A",
        noticePeriod: item?.noticePeriod?.days ?? item.noticePeriod ?? 0,
      }));
      setMailMergeCandidates(mailMergeData);
      toggleMigratedCheckbox(selected, tableResponse, existingCandidatesCB); /////for checkbox
    } else if (source === 3) {
      const updatedCandidatesIds = (monsterTableResponse || [])
        .filter((doc) => selected.includes(doc?.applicantId))
        .map((data) => data?.resumeId)
        .filter(Boolean);

      const targetSet = new Set(updatedCandidatesIds);
      const foundItems = (matchingCandidatesMonster || []).filter((item) =>
        item?.resumeIds?.some((resume) => targetSet.has(resume?.id)),
      );
      const mailMergeData = foundItems.map((item) => ({
        applicantId: item.uiid,
        name: `${item.firstName ?? ""} ${item.lastName ?? ""}`.trim(),
        email: item.email?.primary?.email ?? item.email?.primary ?? "",
        jobTitle: item.jobTitle ?? "-",
        experience: item.exp?.year ? item.exp.year : "-",
        payrate: item.salaryInfo?.payRate?.currency ?? "N/A",
        noticePeriod: item?.noticePeriod?.days ?? item.noticePeriod ?? 0,
      }));
      setMailMergeCandidates(mailMergeData);
      toggleMigratedCheckbox(
        selected,
        monsterTableResponse,
        matchingCandidatesMonster,
      ); ///////for checkbox
    }
  };

  // Pagination Helpers
  const { page, limit, setPage, handleLimitChange } = usePagination(
    25,
    (newPage, newLimit) => {},
  );
  const [noteModal, setNotesModal] = useState(false);

  const tableData =
    source === 2 ? tableResponse : source === 3 ? monsterTableResponse : [];
  const existingData =
    source === 2
      ? existingCandidatesCB
      : source === 3
        ? matchingCandidatesMonster
        : [];
  const matchedMigratedCandidates = selected.every((id) =>
    tableData.some(
      (r) =>
        r.applicantId === id &&
        (existingData || []).some((c) =>
          c?.resumeIds?.some((x) => x.id === r.resumeId),
        ),
    ),
  );
  const showMailMergeForMigrated =
    (source === 2 || source === 3) &&
    selected.length > 0 &&
    matchedMigratedCandidates;

  const getCandidateResume = async () => {
    let uiid = null;
    if (source === 2) {
      uiid = careerBuilderCurrentApplicantIdFullDetails?.uiid;
    } else if (source === 3) {
      uiid = monsterClassicApplicantIdFullDetails?.uiid;
    }
    if (!uiid) return;
    if (source === 2) setCareerBuilderExisting(null);
    if (source === 3) setMonsterExisting(null);
    try {
      const result = await getCandidateResumeFromDB({
        coll: "Candidate",
        fil: { uiid: { type: "NONE", value: uiid } },
        ref: "Resume",
        extret: "uiid firstName",
      });
      if (result.success) {
        const data = result?.data?.data;
        if (source === 2) setCareerBuilderExisting(data);
        if (source === 3) setMonsterExisting(data);
      } else {
        if (source === 2) setCareerBuilderExisting(null);
        if (source === 3) setMonsterExisting(null);
      }
    } catch (err) {
      if (source === 2) setCareerBuilderExisting(null);
      if (source === 3) setMonsterExisting(null);
    }
  };

  useEffect(() => {
    getCandidateResume();
  }, [
    detailsDrawer,
    careerBuilderCurrentApplicantIdFullDetails,
    monsterClassicApplicantIdFullDetails,
    source,
    noteModal,
  ]);

  const handleMigratedProfiles = (currentValueArray) => {
    const isSelected =
      Array.isArray(currentValueArray) && currentValueArray.includes("1");

    if (!isSelected) {
      setDefaultExistingCandidates([]);
      setMailMergeCandidates([]);
      return;
    }

    let matchingCandidates;
    let totalData;
    if (source === 2) {
      matchingCandidates = existingCandidatesCB;
      totalData = tableResponse;
    } else if (source === 3) {
      matchingCandidates = matchingCandidatesMonster;
      totalData = monsterTableResponse;
    }

    // Collect all resumeIds from matching candidates
    const existingResumeIdSet = new Set(
      (matchingCandidates || [])
        .flatMap((candidate) => candidate?.resumeIds || [])
        .map((r) => {
          const id = r?.id ?? r;
          return id ? String(id) : null;
        })
        .filter(Boolean),
    );

    if (existingResumeIdSet.size === 0) {
      setDefaultExistingCandidates([]);
      setMailMergeCandidates([]);
      return;
    }

    // Filter totalData for candidates matching the resumeIds
    const filteredCandidates = (totalData || []).filter((doc) => {
      const docResumeId = doc?.resumeId?.id ?? doc?.resumeId;
      return docResumeId && existingResumeIdSet.has(String(docResumeId));
    });

    // Set mailMergeCandidates in the structured format
    const mailMergeData = filteredCandidates.map((doc) => {
      const foundItem = (matchingCandidates || []).find((item) =>
        item?.resumeIds?.some(
          (resume) =>
            String(resume?.id ?? resume) ===
            String(doc?.resumeId?.id ?? doc?.resumeId),
        ),
      );
      return {
        applicantId: foundItem?.uiid ?? doc?.applicantId,
        name: `${foundItem?.firstName ?? ""} ${
          foundItem?.lastName ?? ""
        }`.trim(),
        email:
          foundItem?.email?.primary?.email ?? foundItem?.email?.primary ?? "",
        jobTitle: foundItem?.jobTitle ?? "-",
        experience: foundItem?.exp?.year ?? "-",
        payrate: foundItem?.salaryInfo?.payRate?.currency ?? "N/A",
        noticePeriod:
          foundItem?.noticePeriod?.days ?? foundItem?.noticePeriod ?? 0,
      };
    });

    setMailMergeCandidates(mailMergeData);

    // Set default selected candidate IDs
    const candidatesIds = filteredCandidates
      .map((doc) => doc?.applicantId)
      .filter(Boolean);
    setDefaultExistingCandidates(candidatesIds);
  };

  const getCandidateFullDetailsForResume = () => {
    switch (source) {
      case 1: {
        return currentApplicantFullDetails;
        break;
      }

      case 2: {
        const targetResumeId =
          careerBuilderCurrentApplicantIdFullDetails?.resumeId;

        const existingResumeIds = careerBuilderExisting?.resumeIds || [];

        const candidateResumeIds =
          existingCandidatesCB?.flatMap((c) => c?.resumeIds || []) || [];

        const hasMatchingResume =
          !!targetResumeId &&
          existingResumeIds.some((r) => r?.id === targetResumeId) &&
          candidateResumeIds.some((r) => r?.id === targetResumeId);

        if (careerBuilderExisting && hasMatchingResume) {
          return careerBuilderExisting;
        }

        // Fallback:
        return careerBuilderCurrentApplicantIdFullDetails;
      }

      case 3: {
        const targetResumeId = monsterClassicApplicantIdFullDetails?.resumeId;
        const existingResumeIds = monsterExisting?.resumeIds || [];
        const candidateResumeIds =
          matchingCandidatesMonster?.flatMap((c) => c?.resumeIds || []) || [];
        const hasMatchingResume =
          !!targetResumeId &&
          existingResumeIds.some((r) => r?.id === targetResumeId) &&
          candidateResumeIds.some((r) => r?.id === targetResumeId);

        if (monsterExisting && hasMatchingResume) {
          return monsterExisting;
        }

        return monsterClassicApplicantIdFullDetails;
      }
    }
  };

  // Total Records Count
  const getTotalRecordsCount = () => {
    switch (source) {
      case 1: {
        return totalApplicantsCount;
        break;
      }

      case 2: {
        return total;
        break;
      }
      case 3: {
        return monsterTotal;
        break;
      }
    }
  };

  // Job Title
  const getCurrentApplicantJobTitle = () => {
    switch (source) {
      case 1: {
        return currentApplicantFullDetails?.jobTitle;
        break;
      }

      case 2: {
        if (careerBuilderExisting) {
          return careerBuilderExisting?.jobTitle;
        }

        return careerBuilderCurrentApplicantIdFullDetails?.resumeTitle;
        break;
      }

      case 3: {
        if (monsterExisting) {
          return monsterExisting?.jobTitle;
        }
        return monsterClassicApplicantIdFullDetails?.jobTitle;
      }
    }
  };

  // Drawer Header Contact Details
  const getCurrentApplicantContactDetailsForHeader = () => {
    switch (source) {
      case 1: {
        return {
          Mobile:
            (currentApplicantFullDetails?.mobile?.primary?.code || "N/A") +
            " " +
            (currentApplicantFullDetails?.mobile?.primary?.number || "N/A"),
          "Job Title": currentApplicantFullDetails?.jobTitle,
          Location:
            (currentApplicantFullDetails?.location?.city || "N/A") +
            "-" +
            (currentApplicantFullDetails?.location?.state?.code ||
              currentApplicantFullDetails?.location?.state ||
              "N/A") +
            "-" +
            (currentApplicantFullDetails?.location?.country?.code ||
              currentApplicantFullDetails?.location?.country ||
              "N/A"),
          "Work Authorizationn": currentApplicantFullDetails?.workAuth || "N/A",
          "Experience(Years)": currentApplicantFullDetails?.exp?.year,
          Email: currentApplicantFullDetails?.email?.primary?.email || "N/A",
        };

        break;
      }

      case 2: {
        const targetResumeId =
          careerBuilderCurrentApplicantIdFullDetails?.resumeId;

        const existingResumeIds = careerBuilderExisting?.resumeIds || [];

        const candidateResumeIds =
          existingCandidatesCB?.flatMap((c) => c?.resumeIds || []) || [];

        const hasMatchingResume =
          !!targetResumeId &&
          existingResumeIds.some((r) => r?.id === targetResumeId) &&
          candidateResumeIds.some((r) => r?.id === targetResumeId);

        if (careerBuilderExisting && hasMatchingResume) {
          return {
            Mobile:
              (careerBuilderExisting?.mobile?.primary?.code ?? "N/A") +
              (careerBuilderExisting?.mobile?.primary?.number ?? "N/A"),
            "Job Title": careerBuilderExisting?.jobTitle ?? "N/A",
            Location:
              (careerBuilderExisting?.location?.city ?? "N/A") +
              "-" +
              (careerBuilderExisting?.location?.state?.code ??
                careerBuilderExisting?.location?.state ??
                "N/A") +
              "-" +
              (careerBuilderExisting?.location?.country?.code ??
                careerBuilderExisting?.location?.country ??
                "N/A"),
            "Work Authorization": careerBuilderExisting?.workAuth ?? "N/A",
            "Experience(Years)": careerBuilderExisting?.exp?.year ?? "N/A",
            Email: careerBuilderExisting?.email?.primary?.email ?? "N/A",
          };
        }

        return {
          Mobile: careerBuilderCurrentApplicantIdFullDetails?.mobile ?? "N/A",
          "Job Title":
            careerBuilderCurrentApplicantIdFullDetails?.resumeTitle ?? "N/A",
          Location:
            careerBuilderCurrentApplicantIdFullDetails?.location ?? "N/A",
          "Work Authorization":
            careerBuilderCurrentApplicantIdFullDetails?.workAuth ?? "N/A",
          "Experience(Years)":
            careerBuilderCurrentApplicantIdFullDetails?.experienceYearsMonths ??
            "N/A",
          Email: careerBuilderCurrentApplicantIdFullDetails?.email ?? "N/A",
        };
      }

      case 3: {
        const targetResumeId = monsterClassicApplicantIdFullDetails?.resumeId;
        const existingResumeIds = monsterExisting?.resumeIds || [];
        const candidateResumeIds =
          matchingCandidatesMonster?.flatMap((c) => c?.resumeIds || []) || [];
        const hasMatchingResume =
          !!targetResumeId &&
          existingResumeIds.some((r) => r?.id === targetResumeId) &&
          candidateResumeIds.some((r) => r?.id === targetResumeId);

        if (monsterExisting && hasMatchingResume) {
          return {
            Mobile: monsterExisting?.mobile?.primary?.number ?? "N/A",
            "Job Title": monsterExisting?.jobTitle ?? "N/A",
            Location:
              (monsterExisting?.location?.city ?? "N/A") +
              "-" +
              (monsterExisting?.location?.state?.code ??
                monsterExisting?.location?.state ??
                "N/A") +
              "-" +
              (monsterExisting?.location?.country?.code ??
                monsterExisting?.location?.country ??
                "N/A"),
            "Work Authorization": monsterExisting?.workAuth ?? "N/A",
            "Experience(Years)": monsterExisting?.exp?.year ?? "exp",
            Email: monsterExisting?.email?.primary?.email ?? "N/A",
          };
        }

        return {
          Mobile: monsterClassicApplicantIdFullDetails?.mobile ?? "N/A",
          "Job Title": monsterClassicApplicantIdFullDetails?.jobTitle ?? "N/A",
          Location: monsterClassicApplicantIdFullDetails?.location ?? "N/A",
          "Work Authorization":
            monsterClassicApplicantIdFullDetails?.workAuthType ?? "N/A",
          "Experience(Years)":
            monsterClassicApplicantIdFullDetails?.experience ?? "N/A",
          Email: monsterClassicApplicantIdFullDetails?.email ?? "N/A",
        };
      }
    }
  };

  // Applicant Personal Details
  //console.log(currentApplicantFullDetails)
  const getCurrentApplicantPersonalDetails = () => {
    switch (source) {
      case 1: {
        return {
          "First Name": formatWords2(
            currentApplicantFullDetails?.firstName || "",
          ),
          "Middle Name": formatWords2(
            currentApplicantFullDetails?.middleName || "",
          ),
          "Last Name": formatWords2(
            currentApplicantFullDetails?.lastName || "",
          ),
          Gender: Gender[currentApplicantFullDetails?.gender] || "",
          "Primary Email":
            currentApplicantFullDetails?.email?.primary?.email ||
            currentApplicantFullDetails?.email?.primary ||
            "",
          State:
            formatWords2(
              currentApplicantFullDetails?.location?.state?.code ||
                currentApplicantFullDetails?.location?.state ||
                "N/A",
            ) +
            "-" +
            formatWords2(
              currentApplicantFullDetails?.location?.country?.code ||
                currentApplicantFullDetails?.location?.country ||
                "N/A" ||
                "",
            ),
          City: formatWords2(currentApplicantFullDetails?.location?.city),
          "Zip Code": currentApplicantFullDetails?.location?.zipCode,
        };
        break;
      }

      case 2: {
        const targetResumeId =
          careerBuilderCurrentApplicantIdFullDetails?.resumeId;

        const existingResumeIds = careerBuilderExisting?.resumeIds || [];

        const candidateResumeIds =
          existingCandidatesCB?.flatMap((c) => c?.resumeIds || []) || [];

        const hasMatchingResume =
          !!targetResumeId &&
          existingResumeIds.some((r) => r?.id === targetResumeId) &&
          candidateResumeIds.some((r) => r?.id === targetResumeId);

        const sourceData =
          careerBuilderExisting && hasMatchingResume
            ? careerBuilderExisting
            : careerBuilderCurrentApplicantIdFullDetails;

        return {
          "First Name": formatWords2(
            sourceData?.firstName || sourceData?.name || "",
          ),
          "Middle Name": formatWords2(sourceData?.middleName || ""),
          "Last Name": formatWords2(sourceData?.lastName || ""),
          Gender: Gender[sourceData?.gender] || "",
          "Primary Email":
            sourceData?.email?.primary?.email ||
            sourceData?.email?.primary ||
            sourceData?.email ||
            "",
          State: formatWords2(
            (sourceData?.location?.state?.code ||
              sourceData?.location?.state) &&
              (sourceData?.location?.country?.code ||
                sourceData?.location?.country)
              ? `${
                  sourceData.location.state.code || sourceData.location.state
                }-${
                  sourceData.location.country.code ||
                  sourceData.location.country
                }`
              : `${sourceData?.state || ""}-${sourceData?.country || ""}`,
          ),
          City: formatWords2(
            sourceData?.location?.city || sourceData?.city || "",
          ),
          "Zip Code":
            sourceData?.location?.zipCode || sourceData?.zipCode || "",
        };
      }

      case 3: {
        const targetResumeId = monsterClassicApplicantIdFullDetails?.resumeId;
        const existingResumeIds = monsterExisting?.resumeIds || [];
        const candidateResumeIds =
          matchingCandidatesMonster?.flatMap((c) => c?.resumeIds || []) || [];
        const hasMatchingResume =
          !!targetResumeId &&
          existingResumeIds.some((r) => r?.id === targetResumeId) &&
          candidateResumeIds.some((r) => r?.id === targetResumeId);

        const sourceData =
          monsterExisting && hasMatchingResume
            ? monsterExisting
            : monsterClassicApplicantIdFullDetails;
        // console.log(sourceData)
        return {
          "First Name": formatWords2(
            sourceData?.firstName || sourceData?.name || "",
          ),
          "Middle Name": formatWords2(sourceData?.middleName || ""),
          "Last Name": formatWords2(sourceData?.lastName || ""),
          // Name: sourceData?.name || `${sourceData?.firstName || ""} ${sourceData?.lastName || ""}`.trim() || "Confidential",
          Name: formatWords2(
            sourceData?.name && sourceData.name !== "n/a"
              ? sourceData.name
              : `${
                  sourceData?.firstName !== "n/a"
                    ? sourceData?.firstName || ""
                    : ""
                } ${
                  sourceData?.lastName !== "n/a"
                    ? sourceData?.lastName || ""
                    : ""
                }`.trim() || "Confidential",
          ),
          Gender: Gender[sourceData?.gender] || "",
          "Primary Email":
            sourceData?.email?.primary?.email ||
            sourceData?.email?.primary ||
            sourceData?.email ||
            "",
          State: formatWords2(
            (sourceData?.location?.state?.code ||
              sourceData?.location?.state) &&
              (sourceData?.location?.country?.code ||
                sourceData?.location?.country)
              ? `${
                  sourceData.location.state.code || sourceData.location.state
                }-${
                  sourceData.location.country.code ||
                  sourceData.location.country
                }`
              : `${sourceData?.state || ""}-${sourceData?.country || ""}`,
          ),
          City: formatWords2(
            sourceData?.location?.city || sourceData?.city || "",
          ),
          "Zip Code":
            sourceData?.location?.zipCode || sourceData?.zipCode || "",
        };
      }
    }
  };

  // Resume
  const getCurrentApplicantResume = () => {
    switch (source) {
      case 1: {
        return currentApplicantFullDetails?.htmlResume;
        break;
      }

      case 2: {
        return null;
        break;
      }

      case 3: {
        return monsterExisting?.htmlResume || null;
      }
    }
  };

  const safeDecode = (v) => {
    try {
      return typeof v === "string" ? decodeURIComponent(v) : v;
    } catch {
      return v;
    }
  };

  const extractJobTitleKeywords = (jobTitle = "") =>
    jobTitle
      .replace(/["()]/g, "")
      .split(/\b(?:AND|OR|NOT)\b/i)
      .map((k) => k.trim())
      .filter((k) => k.length > 0 && !/^(and|or|not)$/i.test(k));

  const decodeMonsterSearchSkills = (skills) => {
    if (!Array.isArray(skills) || skills.length === 0) return [];

    return skills
      .map((skill) => {
        if (typeof skill !== "string") return null;

        const encodedValue = skill.split(" ")[0];

        try {
          return decodeURIComponent(decodeURIComponent(encodedValue));
        } catch {
          return encodedValue;
        }
      })
      .filter(Boolean);
  };

  // Keywords Highlighting
  const getCurrentSearchKeywords = () => {
    switch (source) {
      case 1: {
        const keywordsSkills = searchQuery?.payload?.query.skills || [];
        const rawKeywordString = searchQuery?.payload?.query?.keywords || "";
        const jobTitle = searchQuery?.payload?.query?.jobTitle || "";
        const titleWords = extractJobTitleKeywords(jobTitle);

        const extra = rawKeywordString
          .replace(/["()]/g, "")
          .split(/\b(?:AND|OR|NOT)\b/i)
          .map((k) => k.trim())
          .filter((k) => k.length > 0);

        return [...new Set([...keywordsSkills, ...extra, ...titleWords])];
        break;
      }

      case 2: {
        const jobTitle = searchQuery?.payload?.query?.JobTitle || "";
        const keywords =
          searchQuery?.payload?.query?.Keywords?.replace(
            /\band not\s+\S+/gi,
            "",
          )
            .replace(/[()]/g, "") // remove parentheses
            .match(/"[^"]+"|\S+/g) // keep quoted text as single word
            ?.map((w) => w.replace(/"/g, "")) // remove quotes
            .filter(
              (w) => !/^(and|or|not|and\s+not|not\s+or)$/i.test(w), // SAME filter
            ) || [];
        return [...keywords, ...extractJobTitleKeywords(jobTitle)];
        break;
      }

      case 3: {
        const jobTitle =
          searchQuery?.payload?.query?.q ||
          safeDecode(searchQuery?.payload?.query?.bkeyword) ||
          "";
        const jtTitlesArray = (
          safeDecode(searchQuery?.payload?.query?.jt) || ""
        )
          .split(",")
          .map((k) => k.trim())
          .filter(Boolean);
        const qrjtTitles = (searchQuery?.payload?.query?.qrjt || "")
          .replace(/["()]/g, "")
          .split(/\b(?:AND|OR|NOT)\b/i)
          .map((k) => k.trim())
          .filter((k) => k.length > 0 && !/^(and|or|not)$/i.test(k));
        const skillsArray =
          decodeMonsterSearchSkills(searchQuery?.payload?.query?.sk) || "";
        const queryQ = searchQuery?.payload?.query?.q || "";

        const titleWords = jobTitle
          .replace(/["()]/g, "")
          .split(/\b(?:AND|OR|NOT)\b/i)
          .map((k) => k.trim())
          .filter((k) => k.length > 0 && !/^(and|or|not)$/i.test(k));

        const skillWords = (skillsArray || [])
          .flat()
          .map((str) =>
            (str || "")
              .replace(/["()]/g, "")
              .split(/\b(?:AND|OR|NOT)\b/i)
              .map((k) => k.trim())
              .filter((k) => k.length > 0 && !/^(and|or|not)$/i.test(k)),
          )
          .flat();

        const qWords = queryQ
          .replace(/["()]/g, "")
          .split(/\b(?:AND|OR|NOT)\b/i)
          .map((k) => k.trim())
          .filter((k) => k.length > 0 && !/^(and|or|not)$/i.test(k));

        return [
          ...new Set([
            ...skillWords,
            ...titleWords,
            ...qWords,
            ...jtTitlesArray,
            ...qrjtTitles,
          ]),
        ];
      }

      default:
        return [];
    }
  };

  // Table Columns
  const getTableColumns = () => {
    switch (source) {
      case 1: {
        return [
          // {
          //   key: "icons",
          //   label: "",
          //   render: (row) => (
          //     <div className="flex items-center gap-1">
          //       {row.notes && row.notes.length > 0 && (
          //         <div
          //           onMouseEnter={() =>
          //             row?.notes?.length > 0 ? getHoveredNotes(row?.notes) : {}
          //           }
          //           onMouseLeave={() => setHoveredNotes([])}
          //         >
          //           <SmartTooltip
          //             description={
          //               Array.isArray(hoveredNotes) &&
          //               hoveredNotes?.length > 0 ? (
          //                 <div className="flex flex-col gap-2">
          //                   {hoveredNotes?.map((hoveredNote, i) => (
          //                     <p key={i}>
          //                       "{hoveredNote?.note || ""}" by{" "}
          //                       {formatWords2(
          //                         hoveredNote?.addedBy?.firstName,
          //                       ) || ""}{" "}
          //                       on{" "}
          //                       {dateFormator(
          //                         convertFromUTC(hoveredNote?.addedOn),
          //                         "datetime-ampm",
          //                       ) || ""}
          //                     </p>
          //                   ))}
          //                 </div>
          //               ) : (
          //                 "Add note"
          //               )
          //             }
          //             noicon
          //           >
          //             <DualIcon
          //               icon="chat"
          //               size="sm"
          //               badgeIconColor={
          //                 row?.notes?.length > 0 ? "bg-success" : "bg-dark"
          //               }
          //               onClick={() => {
          //                 setNotesModal(true);
          //                 setCurrentApplicantId(row.uiid);
          //               }}
          //             />
          //           </SmartTooltip>
          //         </div>
          //       )}

          //       <SmartTooltip description={"View Resume"} noicon>
          //         <Button
          //           type="icon"
          //           size="sm"
          //           variant="text"
          //           icon="visibility"
          //           color="black"
          //           onClick={() => {
          //             setDetailsDrawer(true);
          //             setCurrentApplicantId(row.uiid);
          //           }}
          //         />
          //       </SmartTooltip>

          //       {row?.uiid && (
          //         <SmartTooltip
          //           description={`Migrated by ${formatWords2(
          //             row?.addedBy ?? "-",
          //           )} on ${dateFormator(row?.addedOn ?? "-")}`}
          //           noicon
          //         >
          //           <Button
          //             type="icon"
          //             size="sm"
          //             variant="text"
          //             icon="save"
          //             color="black"
          //           />
          //         </SmartTooltip>
          //       )}
          //     </div>
          //   ),
          //   columnMenu: false,
          // },
          {
            key: "icons",
            label: "",
            columnMenu: false,
            render: (row) => {
              const notes = Array.isArray(row?.notes) ? row.notes : [];
              const hasNotes = notes.length > 0;
              return (
                <div className="flex items-center gap-1">
                  {hasNotes && (
                    <div
                      onMouseEnter={() => getHoveredNotes(notes)}
                      onMouseLeave={() => setHoveredNotes([])}
                    >
                      <SmartTooltip
                        noicon
                        description={
                          hoveredNotes?.length > 0 ? (
                            <div className="flex flex-col gap-2">
                              {hoveredNotes.map((note, i) => (
                                <p key={i}>
                                  "{note?.note ?? ""}" by{" "}
                                  {formatWords2(note?.addedBy?.firstName) ?? ""}{" "}
                                  on{" "}
                                  {dateFormator(
                                    convertFromUTC(note?.addedOn),
                                    "datetime-ampm",
                                  ) ?? ""}
                                </p>
                              ))}
                            </div>
                          ) : (
                            "Add note"
                          )
                        }
                      >
                        <DualIcon
                          icon="chat"
                          size="sm"
                          badgeIconColor={hasNotes ? "bg-success" : "bg-dark"}
                          onClick={() => {
                            setNotesModal(true);
                            setCurrentApplicantId(row?.uiid);
                          }}
                        />
                      </SmartTooltip>
                    </div>
                  )}
                  <SmartTooltip description="View Resume" noicon>
                    <Button
                      type="icon"
                      size="sm"
                      variant="text"
                      icon="visibility"
                      color="black"
                      onClick={() => {
                        setDetailsDrawer(true);
                        setCurrentApplicantId(row?.uiid);
                      }}
                    />
                  </SmartTooltip>
                  {row?.uiid && (
                    <SmartTooltip
                      noicon
                      description={`Migrated by ${formatWords2(
                        row?.addedBy ?? "-",
                      )} on ${dateFormator(row?.addedOn ?? "-")}`}
                    >
                      <Button
                        type="icon"
                        size="sm"
                        variant="text"
                        icon="save"
                        color="black"
                      />
                    </SmartTooltip>
                  )}
                </div>
              );
            },
          },
          {
            key: "applicantId",
            label: "ID",
            render: (row) => (
              <div className="flex items-center gap-2">
                {row.source == 2 || row.source == 3 ? (
                  <Avatar size="xs-sm" src={pic} />
                ) : (
                  <Avatar alt={row.name} showInitials={true} size="xs-sm" />
                )}
                {row.applicantId}
              </div>
            ),
            width: "w-32",
          },

          {
            key: "name",
            label: "Name",
            width: "min-w-40",
            render: (row) => <div className="text-nowrap">{row.name}</div>,
          },
          {
            key: "location",
            label: "Location",
            width: "min-w-52 max-w-60",
            //render: (row) => <div className="line-clamp-1">{row.location}</div>,
          },

          {
            key: "jobTitle",
            label: "Job Title",
            width: "min-w-52 max-w-60",
            //render: (row) => <div className="line-clamp-1">{row.jobTitle}</div>,
          },
          {
            key: "email",
            label: "Email ID",
            render: (row) => {
              const { email } = row;
              return email ? (
                <div className={"flex items-center gap-0.5 "}>
                  <CopyToClipboard
                    tooltipPosition="right"
                    content={email}
                    title={email}
                  />
                  {email}
                </div>
              ) : (
                ""
              );
            },
          },
          {
            key: "contact",
            label: "Contact Number",
            render: (row) => (
              <div className="flex items-center">
                <SmartTooltip description={"Phone"} noicon>
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    size="sm"
                    icon={"phone_in_talk"}
                  />
                </SmartTooltip>
                {row.contact}
                <SmartTooltip description={"text"} noicon>
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    icon={"chat"}
                    size="sm"
                  />
                </SmartTooltip>
                <SmartTooltip description={"Whatsapp"} noicon>
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    icon={whatsappIcon}
                  />
                </SmartTooltip>
              </div>
            ),
          },

          {
            key: "experience",
            label: "Experience",
          },
          {
            key: "workAuthorization",
            label: "Work Authorization",
          },

          {
            key: "source",
            label: "Source",
            width: "min-w-40",
            render: (row) => <div className="line-clamp-1">{row.source}</div>,
          },
          {
            key: "currentCTC",
            label: "Current CTC",
          },
          {
            key: "noticePeriod",
            label: "Notice Period",
          },
          {
            key: "createdBy",
            label: "Created By",
          },
          {
            key: "lastActive",
            label: "Last Active",
          },
        ];

        break;
      }

      case 2: {
        return [
          // {
          //   key: "icons",
          //   label: "",
          //   render: (row) => (
          //     <div className="flex items-center gap-1">
          //       {existingCandidatesCB?.find((c) =>
          //         (c?.resumeIds || []).some((r) => r?.id === row?.resumeId),
          //       )?.notes?.length > 0 && (
          //         <div
          //           onMouseEnter={() => {
          //             const isMatched = existingCandidatesCB?.find((c) =>
          //               (c?.resumeIds || []).some(
          //                 (r) => r?.id === row?.resumeId,
          //               ),
          //             );
          //             const uiids = isMatched?.notes
          //               .filter((n) => n && typeof n === "object" && n?.uiid)
          //               .map((n) => n.uiid);

          //             const others = isMatched?.notes.filter(
          //               (n) => !(n && typeof n === "object" && n?.uiid),
          //             );
          //             const merged = [...uiids, ...others];
          //             getHoveredNotes(merged);
          //           }}
          //           onMouseLeave={() => setHoveredNotes([])}
          //         >
          //           <SmartTooltip
          //             description={
          //               Array.isArray(hoveredNotes) &&
          //               hoveredNotes?.length > 0 ? (
          //                 <div className="flex flex-col gap-2">
          //                   {hoveredNotes?.map((hoveredNote, i) => (
          //                     <p key={i}>
          //                       "{hoveredNote?.note || ""}" by{" "}
          //                       {formatWords2(
          //                         hoveredNote?.addedBy?.firstName,
          //                       ) || ""}{" "}
          //                       on{" "}
          //                       {dateFormator(
          //                         convertFromUTC(hoveredNote?.addedOn),
          //                         "datetime-ampm",
          //                       ) || ""}
          //                     </p>
          //                   ))}
          //                 </div>
          //               ) : (
          //                 "Add note"
          //               )
          //             }
          //             noicon
          //           >
          //             <DualIcon
          //               icon="chat"
          //               size="sm"
          //               badgeIconColor={
          //                 existingCandidatesCB?.find((c) =>
          //                   (c?.resumeIds || []).some(
          //                     (r) => r?.id === row?.resumeId,
          //                   ),
          //                 )?.notes?.length > 0
          //                   ? "bg-success"
          //                   : "bg-dark"
          //               }
          //               onClick={() => {
          //                 const isMatched = existingCandidatesCB?.some((c) =>
          //                   (c?.resumeIds || []).some(
          //                     (r) => r?.id === row?.resumeId,
          //                   ),
          //                 );
          //                 //console.log("asasa")
          //                 if (isMatched) {
          //                   setNotesModal(true);
          //                 }

          //                 setCareerBuilderCurrentApplicantId(row.applicantId);
          //               }}
          //             />
          //           </SmartTooltip>
          //         </div>
          //       )}

          //       <SmartTooltip description={"View Resume"} noicon>
          //         <Button
          //           type="icon"
          //           size="sm"
          //           variant="text"
          //           icon="visibility"
          //           color="black"
          //           onClick={() => {
          //             setDetailsDrawer(true);
          //             setCareerBuilderCurrentApplicantId(row.applicantId);
          //           }}
          //         />
          //       </SmartTooltip>

          //       {existingCandidatesCB?.some((c) =>
          //         (c?.resumeIds || []).some((r) => r?.id === row?.resumeId),
          //       ) && (
          //         <SmartTooltip
          //           description={(() => {
          //             const migratedCandidate = existingCandidatesCB?.find(
          //               (c) =>
          //                 (c?.resumeIds || []).some(
          //                   (r) => r?.id === row?.resumeId,
          //                 ),
          //             );

          //             return migratedCandidate
          //               ? `Migrated by ${formatWords2(
          //                   migratedCandidate?.addedBy?.firstName ?? "-",
          //                 )} on ${dateFormator(
          //                   migratedCandidate?.addedOn ?? "-",
          //                 )}`
          //               : "Migrated";
          //           })()}
          //           noicon
          //         >
          //           <Button
          //             type="icon"
          //             size="sm"
          //             variant="text"
          //             icon="save"
          //             color="black"
          //           />
          //         </SmartTooltip>
          //       )}
          //     </div>
          //   ),
          //   columnMenu: false,
          // },
          {
            key: "icons",
            label: "",
            columnMenu: false,
            render: (row) => {
              const matchedCandidate = (existingCandidatesCB ?? []).find((c) =>
                (c?.resumeIds ?? []).some(
                  (r) => String(r?.id) === String(row?.resumeId),
                ),
              );
              const notes = Array.isArray(matchedCandidate?.notes)
                ? matchedCandidate.notes
                : [];
              const hasNotes = notes.length > 0;
              return (
                <div className="flex items-center gap-1">
                  {hasNotes && (
                    <div
                      onMouseEnter={() => {
                        const uiids = notes
                          .filter((n) => n && typeof n === "object" && n?.uiid)
                          .map((n) => n.uiid);

                        const others = notes.filter(
                          (n) => !(n && typeof n === "object" && n?.uiid),
                        );

                        getHoveredNotes([...uiids, ...others]);
                      }}
                      onMouseLeave={() => setHoveredNotes([])}
                    >
                      <SmartTooltip
                        noicon
                        description={
                          hoveredNotes?.length > 0 ? (
                            <div className="flex flex-col gap-2">
                              {hoveredNotes.map((note, i) => (
                                <p key={i}>
                                  "{note?.note || ""}" by{" "}
                                  {formatWords2(note?.addedBy?.firstName) || ""}{" "}
                                  on{" "}
                                  {dateFormator(
                                    convertFromUTC(note?.addedOn),
                                    "datetime-ampm",
                                  ) || ""}
                                </p>
                              ))}
                            </div>
                          ) : (
                            "Add note"
                          )
                        }
                      >
                        <DualIcon
                          icon="chat"
                          size="sm"
                          badgeIconColor={hasNotes ? "bg-success" : "bg-dark"}
                          onClick={() => {
                            if (matchedCandidate) {
                              setNotesModal(true);
                            }

                            setCareerBuilderCurrentApplicantId(row.applicantId);
                          }}
                        />
                      </SmartTooltip>
                    </div>
                  )}
                  <SmartTooltip description={"View Resume"} noicon>
                    <Button
                      type="icon"
                      size="sm"
                      variant="text"
                      icon="visibility"
                      color="black"
                      onClick={() => {
                        setDetailsDrawer(true);
                        setCareerBuilderCurrentApplicantId(row.applicantId);
                      }}
                    />
                  </SmartTooltip>
                  {matchedCandidate && (
                    <SmartTooltip
                      noicon
                      description={`Migrated by ${formatWords2(
                        matchedCandidate?.addedBy?.firstName ?? "-",
                      )} on ${dateFormator(matchedCandidate?.addedOn ?? "-")}`}
                    >
                      <Button
                        type="icon"
                        size="sm"
                        variant="text"
                        icon="save"
                        color="black"
                      />
                    </SmartTooltip>
                  )}
                </div>
              );
            },
          },
          {
            key: "name",
            label: "Name",
            width: "min-w-[200px]! max-w-[280px]!",
            render: (row) => <div className="text-nowrap">{row.name}</div>,
          },
          {
            key: "location",
            label: "Location",
            width: "min-w-[200px]! max-w-[250px]!",
          },
          {
            key: "jobTitle",
            label: "Job Title",
            width: "min-w-[200px]! max-w-[250px]!",
          },
          {
            key: "experience",
            label: "Experience",
            width: "min-w-[150px]! max-w-[200px]!",
          },
          {
            key: "highestEducation",
            label: "Highest Education",
            width: "min-w-[200px]! max-w-[250px]!",
          },
          {
            key: "source",
            label: "Source",
            width: "min-w-[150px]! max-w-[200px]!",
            render: (row) => (
              <span className="text-xs font-medium text-gray-700">
                {row.source === 2 ? "Career Builder" : "Other"}
              </span>
            ),
          },
          {
            key: "lastUpdate",
            label: "Last Updated",
            width: "min-w-[150px]! max-w-[200px]!",
            render: (row) => (
              <span className="text-xs text-gray-600">{row.lastUpdate}</span>
            ),
          },
        ];
      }
      case 3: {
        return [
          // {
          //   key: "icons",
          //   label: "",
          //   render: (row) => (
          //     <div className="flex items-center gap-1">
          //       {matchingCandidatesMonster?.find((c) =>
          //         (c?.resumeIds || []).some((r) => r?.id === row?.resumeId),
          //       )?.notes?.length > 0 && (
          //         <div
          //           onMouseEnter={() => {
          //             const isMatched = matchingCandidatesMonster?.find((c) =>
          //               (c?.resumeIds || []).some(
          //                 (r) => r?.id === row?.resumeId,
          //               ),
          //             );
          //             const uiids = isMatched?.notes
          //               .filter((n) => n && typeof n === "object" && n?.uiid)
          //               .map((n) => n.uiid);

          //             const others = isMatched?.notes.filter(
          //               (n) => !(n && typeof n === "object" && n?.uiid),
          //             );
          //             const merged = [...uiids, ...others];
          //             getHoveredNotes(merged);
          //           }}
          //           onMouseLeave={() => setHoveredNotes([])}
          //         >
          //           <SmartTooltip
          //             description={
          //               Array.isArray(hoveredNotes) &&
          //               hoveredNotes?.length > 0 ? (
          //                 <div className="flex flex-col gap-2">
          //                   {hoveredNotes?.map((hoveredNote, i) => (
          //                     <p key={i}>
          //                       "{hoveredNote?.note || ""}" by{" "}
          //                       {formatWords2(
          //                         hoveredNote?.addedBy?.firstName,
          //                       ) || ""}{" "}
          //                       on{" "}
          //                       {dateFormator(
          //                         convertFromUTC(hoveredNote?.addedOn),
          //                         "datetime-ampm",
          //                       ) || ""}
          //                     </p>
          //                   ))}
          //                 </div>
          //               ) : (
          //                 "Add note"
          //               )
          //             }
          //             noicon
          //           >
          //             <DualIcon
          //               icon="chat"
          //               size="sm"
          //               badgeIconColor={
          //                 matchingCandidatesMonster?.find((c) =>
          //                   (c?.resumeIds || []).some(
          //                     (r) => r?.id === row?.resumeId,
          //                   ),
          //                 )?.notes?.length > 0
          //                   ? "bg-success"
          //                   : "bg-dark"
          //               }
          //               onClick={() => {
          //                 const isMatched = matchingCandidatesMonster?.some(
          //                   (c) =>
          //                     (c?.resumeIds || []).some(
          //                       (r) => r?.id === row?.resumeId,
          //                     ),
          //                 );
          //                 //console.log("asasa")
          //                 if (isMatched) {
          //                   setNotesModal(true);
          //                 }

          //                 setMonsterClassicApplicantId(row.applicantId);
          //               }}
          //             />
          //           </SmartTooltip>
          //         </div>
          //       )}

          //       <SmartTooltip description={"View Resume"} noicon>
          //         <Button
          //           type="icon"
          //           size="sm"
          //           variant="text"
          //           icon="visibility"
          //           color="black"
          //           onClick={() => {
          //             setDetailsDrawer(true);
          //             setMonsterClassicApplicantId(row.applicantId);
          //           }}
          //         />
          //       </SmartTooltip>
          //       {/* matchingCandidates */}
          //       {matchingCandidatesMonster?.some((c) =>
          //         (c?.resumeIds || []).some((r) => r?.id === row?.resumeId),
          //       ) && (
          //         <SmartTooltip
          //           description={(() => {
          //             const migratedCandidate = matchingCandidatesMonster?.find(
          //               (c) =>
          //                 (c?.resumeIds || []).some(
          //                   (r) => r?.id === row?.resumeId,
          //                 ),
          //             );

          //             return migratedCandidate
          //               ? `Migrated by ${formatWords2(
          //                   migratedCandidate?.addedBy?.firstName ?? "-",
          //                 )} on ${dateFormator(
          //                   migratedCandidate?.addedOn ?? "-",
          //                 )}`
          //               : "Migrated";
          //           })()}
          //           noicon
          //         >
          //           <Button
          //             type="icon"
          //             size="sm"
          //             variant="text"
          //             icon="save"
          //             color="black"
          //           />
          //         </SmartTooltip>
          //       )}
          //     </div>
          //   ),
          //   columnMenu: false,
          // },
          {
            key: "icons",
            label: "",
            columnMenu: false,

            render: (row) => {
              const matchedCandidate = (matchingCandidatesMonster ?? []).find(
                (c) =>
                  (c?.resumeIds ?? []).some(
                    (r) => String(r?.id) === String(row?.resumeId),
                  ),
              );
              const notes = Array.isArray(matchedCandidate?.notes)
                ? matchedCandidate.notes
                : [];
              const hasNotes = notes.length > 0;
              return (
                <div className="flex items-center gap-1">
                  {hasNotes && (
                    <div
                      onMouseEnter={() => {
                        const uiids = notes
                          .filter((n) => n && typeof n === "object" && n?.uiid)
                          .map((n) => n.uiid);

                        const others = notes.filter(
                          (n) => !(n && typeof n === "object" && n?.uiid),
                        );

                        getHoveredNotes([...uiids, ...others]);
                      }}
                      onMouseLeave={() => setHoveredNotes([])}
                    >
                      <SmartTooltip
                        noicon
                        description={
                          hoveredNotes?.length > 0 ? (
                            <div className="flex flex-col gap-2">
                              {hoveredNotes.map((note, i) => (
                                <p key={i}>
                                  "{note?.note || ""}" by{" "}
                                  {formatWords2(note?.addedBy?.firstName) || ""}{" "}
                                  on{" "}
                                  {dateFormator(
                                    convertFromUTC(note?.addedOn),
                                    "datetime-ampm",
                                  ) || ""}
                                </p>
                              ))}
                            </div>
                          ) : (
                            "Add note"
                          )
                        }
                      >
                        <DualIcon
                          icon="chat"
                          size="sm"
                          badgeIconColor={hasNotes ? "bg-success" : "bg-dark"}
                          onClick={() => {
                            if (matchedCandidate) {
                              setNotesModal(true);
                            }

                            setMonsterClassicApplicantId(row.applicantId);
                          }}
                        />
                      </SmartTooltip>
                    </div>
                  )}
                  <SmartTooltip description="View Resume" noicon>
                    <Button
                      type="icon"
                      size="sm"
                      variant="text"
                      icon="visibility"
                      color="black"
                      onClick={() => {
                        setDetailsDrawer(true);
                        setMonsterClassicApplicantId(row.applicantId);
                      }}
                    />
                  </SmartTooltip>
                  {matchedCandidate && (
                    <SmartTooltip
                      noicon
                      description={`Migrated by ${formatWords2(
                        matchedCandidate?.addedBy?.firstName ?? "-",
                      )} on ${dateFormator(matchedCandidate?.addedOn ?? "-")}`}
                    >
                      <Button
                        type="icon"
                        size="sm"
                        variant="text"
                        icon="save"
                        color="black"
                      />
                    </SmartTooltip>
                  )}
                </div>
              );
            },
          },
          {
            key: "name",
            label: "Name",
            width: "min-w-[200px]! max-w-[280px]!",
            render: (row) => <div className="text-nowrap">{row.name}</div>,
          },
          {
            key: "location",
            label: "Location",
            width: "min-w-[180px]! max-w-[250px]!",
          },
          {
            key: "jobTitle",
            label: "Job Title",
            width: "min-w-[250px]! max-w-[270px]!",
          },
          {
            key: "relocation",
            label: "Relocation",
            width: "min-w-[200px]! max-w-[250px]!",
          },
          {
            key: "lastUpdate",
            label: "Last Updated",
            width: "min-w-[200px]! max-w-[250px]!",
          },
          {
            key: "highestEducation",
            label: "Highest Education",
            width: "min-w-[200px]! max-w-[250px]!",
          },
          {
            key: "jobType",
            label: "Desired Job Type",
            width: "min-w-[200px]! max-w-[250px]!",
          },
          {
            key: "experience",
            label: "Experience",
            width: "min-w-[200px]! max-w-[250px]!",
          },
          {
            key: "source",
            label: "Source",
            width: "min-w-[150px]! max-w-[200px]!",
            render: (row) => (
              <span className="text-xs font-medium text-gray-700">
                {"Monster"}
              </span>
            ),
          },
        ];
      }
    }
  };
  //console.log(monsterTableResponse)
  // Table Rows
  // console.log(tableResponse)
  //  console.log(monsterTableResponse)
  const formatLocation = (location = "N/A") => {
    if (!location || location === "N/A") return "N/A";

    let parts = location
      .split("-")
      .map((p) => p.trim())
      .filter(Boolean);

    // Ignore country code
    if (parts[0]?.toUpperCase() === "US") {
      parts.shift();
    }

    // No state available
    if (parts.length === 0) return "N/A";

    const state = parts[0] || "N/A";
    const city = parts[1] || "N/A";

    return `${state}, ${city}`;
  };

  useEffect(() => {
    setSelected([]);
    setDefaultExistingCandidates([]);
    setMailMergeCandidates([]);
    setSelectedMigratedProfiles([]);
  }, [page, limit]);

  const getTableRows = () => {
    switch (source) {
      case 1: {
        return Array.from({ length: totalRecords }, (_, i) => ({
          id: totalApplicants[i]?.mongoId || totalApplicants[i]?.uiid,
          uiid: totalApplicants[i]?.uiid,
          sno: i,
          applicantId: totalApplicants[i]?.uiid,
          name: formatWords2(
            totalApplicants[i]?.firstName + " " + totalApplicants[i]?.lastName,
          ),
          location:
            (totalApplicants[i]?.location?.city || "N/A") +
            "-" +
            (totalApplicants[i]?.location?.state?.code ||
              totalApplicants[i]?.location?.state ||
              "N/A") +
            "-" +
            // (totalApplicants[i]?.location?.country?.code ||
            //   totalApplicants[i]?.location?.country ||
            //   "N/A"),
            (totalApplicants[i]?.location?.zipCode || "N/A"),
          jobTitle: formatWords2(totalApplicants[i]?.jobTitle),
          email:
            totalApplicants[i]?.email?.primary?.email ??
            totalApplicants[i]?.email?.primary ??
            "N/A",
          contact:
            formatPhoneNumberLength(
              "+1",
              totalApplicants[i]?.mobile?.primary?.number,
            ) ?? "N/A",

          experience: totalApplicants[i]?.exp?.year ?? "-",
          workAuthorization: totalApplicants[i]?.workAuth || "N/A",
          source: getJobBoardsName[totalApplicants[i]?.source],
          addedBy: formatWords2(totalApplicants[i]?.addedBy?.firstName),
          addedOn: totalApplicants[i]?.addedOn ?? "-",
          notes: totalApplicants[i]?.notes ?? [],
        }));
      }

      case 2: {
        return Array.from({ length: tableResponse?.length }, (_, i) => ({
          id: tableResponse[i]?.applicantId,
          applicantId: tableResponse[i]?.applicantId,
          name: formatWords2(tableResponse[i]?.name),
          location:
            tableResponse[i]?.location
              ?.split("-")
              ?.slice(1)
              ?.reverse()
              ?.join("-") ?? "N/A",
          jobTitle: formatWords2(tableResponse[i]?.jobTitle),
          experience: tableResponse[i]?.experience ?? "-",
          highestEducation: formatWords2(tableResponse[i]?.highestEducation),
          source: tableResponse[i]?.source,
          lastUpdate: tableResponse[i]?.lastUpdate ?? "-",
          resumeId: tableResponse[i]?.resumeId,
          uiid: tableResponse[i]?.uiid,
        }));
      }

      case 3: {
        return Array.from(
          { length: monsterTableResponse?.length || 0 },
          (_, i) => ({
            id: monsterTableResponse[i]?.applicantId,
            applicantId: monsterTableResponse[i]?.applicantId,
            name: formatWords2(monsterTableResponse[i]?.name ?? "N/A"),
            location:
              formatLocation(monsterTableResponse[i]?.location) ?? "N/A",
            // location: monsterTableResponse[i]?.location ?? "N/A",
            jobTitle: formatWords2(monsterTableResponse[i]?.jobTitle ?? "N/A"),
            relocation: monsterTableResponse[i]?.relocation ?? "N/A",
            lastUpdate: monsterTableResponse[i]?.lastUpdate ?? "N/A",
            highestEducation:
              monsterTableResponse[i]?.highestEducation ?? "N/A",
            jobType: monsterTableResponse[i]?.jobType ?? "N/A",
            jobDescription:
              monsterTableResponse[i]?.experienceDescription ?? "N/A",
            previousJobTitle:
              `${monsterTableResponse[i]?.experienceJobTitle ?? ""} ${
                monsterTableResponse[i]?.experienceCompany ?? ""
              }`.trim() || "N/A",
            experience: monsterTableResponse[i]?.experience ?? "N/A",
            source: monsterTableResponse[i]?.source ?? "Monster Classic",
            resumeId: monsterTableResponse[i]?.resumeId,
            skills: monsterTableResponse[i]?.skills,
            Relevance: (
              Number(monsterTableResponse[i]?.Relevance || 0) * 10
            )?.toFixed(1),
          }),
        );
      }
    }
  };
  //(totalApplicants)
  //console.log(monsterTableResponse)
  // Table Rows and Columns
  const mappedRowSearchResults = mapTableRows(
    getTableRows(),
    getTableColumns(),
  );

  const filteredMonsterMailMergeData = mappedRowSearchResults.filter((row) =>
    selected.includes(row.applicantId),
  );

  // Common
  const whatsappIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="14"
      height="14"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="WhatsApp"
    >
      <title>WhatsApp</title>

      <path
        fill="#25D366"
        d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 .02 5.35.02 12c0 2.11.55 4.08 1.6 5.83L0 24l6.42-1.68A11.94 11.94 0 0 0 12 24c6.63 0 12-5.35 12-12 0-3.2-1.25-6.2-3.48-8.32z"
      />

      <path
        fill="#FFFFFF"
        d="M17.56 14.01c-.3-.15-1.76-.86-2.03-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.95 1.15-.17.2-.34.22-.64.07-.3-.15-1.27-.47-2.42-1.48-.9-.8-1.51-1.78-1.69-2.08-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.29.3-.48.1-.2.05-.37-.03-.52-.08-.15-.67-1.6-.92-2.19-.24-.57-.48-.49-.66-.5l-.56-.01c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.48 1.06 2.88 1.21 3.08c.15.2 2.09 3.2 5.07 4.48 2.98 1.29 2.98.86 3.52.81.54-.05 1.76-.72 2.01-1.41.25-.69.25-1.28.17-1.41-.08-.13-.27-.2-.57-.35z"
      />
    </svg>
  );

  // Update Function for Page and Limit
  const updateQuery = () => {
    const updatedQuery = {
      ...searchQuery,
      payload: {
        ...searchQuery?.payload,
        query: {
          ...searchQuery?.payload?.query,
          ...(source === 2 && careerBuilderSort
            ? { sortBy: careerBuilderSort }
            : source === 3 && monsterSort
              ? { sort: monsterSort }
              : {}),
        },
        page,
        lim: limit,
      },
    };
    setSearchQuery(updatedQuery);
    const selectedAction = actionMap[source];
    if (selectedAction) {
      dispatch(selectedAction({ ...updatedQuery, onSuccess: () => {} }));
    }
  };

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    updateQuery();
  }, [limit, page, careerBuilderSort, monsterSort]);

  const handleLimitChangeWithReset = (newLimit) => {
    setSelected([]);
    setDefaultExistingCandidates([]);
    setMailMergeCandidates([]);
    setSelectedMigratedProfiles([]);
    handleLimitChange(newLimit);
  };

  const handlePageChange = (newPage) => {
    setSelected([]);
    setDefaultExistingCandidates([]);
    setMailMergeCandidates([]);
    setSelectedMigratedProfiles([]);
    setPage(newPage);
  };

  const gridFilterMap = {
    1: <div></div>,
    2: (
      <CareerBuilderFiltersModal
        query={searchQuery}
        updateQuery={(value) => setSearchQuery(value)}
      />
    ),
    3: (
      <MonsterFiltersModal
        source={source}
        query={searchQuery}
        updateQuery={(value) => {
          setSearchQuery(value);
        }}
      />
    ),
  };
  const cbNoResumeCandidates = tableResponse?.filter(
    (item) => !existingCandidatesCB?.some((ex) => ex?.uiid === item?.uiid),
  );

  const fetchCBSubmissions = async () => {
    const formattedNoResumeCandidates = {
      resumeIds: cbNoResumeCandidates.map((c) => c.resumeId).slice(0, 10),
      jobTitles: cbNoResumeCandidates.map((c) => c.jobTitle).slice(0, 10),
      addedBy: loginUserUiid,
      // skillsToSearch: [cBQuery?.payload?.query?.Keywords] || ""
    };

    //console.log(def);

    try {
      const params = {
        coll: "IntegrationAccess",
        fil: {
          userId: {
            type: "FIND_INTIGRATION_ACCESS",
            value: loginUserUiid,
            category: 3,
            categoryType: 2,
            status: 1,
          },
        },
        useAggregate: true,
      };
      //const response = await getAllIntegrationAccess(params);

      const accessId = accessData?.careerBuilder?.[0]?.uiid
        ? accessData?.careerBuilder?.[0]?.uiid
        : dispatch(setcareerBuilderAccessidStart(params));

      //console.log(accessId)

      const action = {
        accessId: accessId,
        payload: formattedNoResumeCandidates,
        userId: loginUserUiid,
      };
      try {
        const result = await new Promise((resolve, reject) => {
          dispatch(
            fetchCBBulkResumesDataStart({
              ...action,
              resolve,
              reject,
            }),
          );
        });

        setMigrateProfilesModalOpen(false);
        if (
          result?.newApplicant.length > 0 ||
          result?.existingApplicant.length > 0
        ) {
          const count =
            (result?.newApplicant.length ?? 0) +
            (result?.existingApplicant.length ?? 0);
          showToast(`${count} Profiles Migrated Successfully`, "success", 2000);
        } else if (
          result?.failedResumes.length > 0 &&
          result?.failedResumes[0]?.error ==
            "Credits Expired. Please contact manager."
        ) {
          showToast("Credits Expired. Please contact manager.", "error", 3000);
        } else {
          showToast("Profiles Migration Unsuccessful", "error", 2000);
        }
        updateQuery();
      } catch (error) {
        showToast("Profiles Migration Unsuccessful", "error", 2000);
        console.error(error);
      }
    } catch (err) {
      showToast("Profiles Migration Unsuccessful", "error", 2000);
      console.error("Error fetching ResumeMining:", err);
    }
  };

  // console.log(monsterFullResponse)

  const monsterNoResumeCandidates = monsterFullResponse?.filter(
    (item) => item?.uiid === null,
  );

  const handleCountNoResData = () => {
    if (source === 2) {
      setNoResCandidates(cbNoResumeCandidates?.length ?? 0);
    }
    if (source === 3) {
      setNoResCandidates(monsterNoResumeCandidates?.length ?? 0);
    }
  };

  const fetchSubmissions = async () => {
    const formattedCandidates = monsterNoResumeCandidates
      .slice(0, 10)
      .map((data) => ({
        resumeId: data?.resumeId,
        resumeBoardId: 1,
        firstName: data?.firstName,
        middleName: "",
        lastName: data?.lastName,
        addedBy: user?.data?.uiid,
        jobTitle: data.jobTitle || "",
        workAuth: `${data?.workAuthType} ${data?.workAuthCountry}`,
        workHistory: [
          {
            companyName: data?.experienceCompany | "",
            jobDetails: {
              title: data?.experienceJobTitle,
            },
          },
        ],
        militaryExp: {},
        educationDetails: [
          {
            degree: data?.highestEducation,
          },
        ],
        orgName: "tektree llc",
      }));

    try {
      const params = {
        coll: "IntegrationAccess",
        fil: {
          userId: {
            type: "FIND_INTIGRATION_ACCESS",
            value: loginUserUiid,
            category: 3,
            categoryType: 1,
            status: 1,
          },
        },
        useAggregate: true,
      };
      //const response = await getAllIntegrationAccess(params);

      const accessId = accessData?.monster?.[0]?.uiid
        ? accessData?.monster?.[0]?.uiid
        : dispatch(setMonsterAccessidStart(params));

      //console.log(accessId)

      const action = {
        accessId: accessId,
        payload: formattedCandidates,
        userId: loginUserUiid,
      };

      try {
        const result = await new Promise((resolve, reject) => {
          dispatch(
            fetchBulkResumesDataStart({
              ...action,
              resolve,
              reject,
            }),
          );
        });

        setMigrateProfilesModalOpen(false);
        if (
          result?.newApplicant.length > 0 ||
          result?.existingApplicant.length > 0
        ) {
          const count =
            (result?.newApplicant.length ?? 0) +
            (result?.existingApplicant.length ?? 0);
          showToast(`${count} Profiles Migrated Successfully`, "success", 2000);
        } else if (
          result?.failedResumes.length > 0 &&
          result?.failedResumes[0]?.error ==
            "Credits Expired. Please contact manager."
        ) {
          showToast("Credits Expired. Please contact manager.", "error", 3000);
        } else {
          showToast("Profiles Migration Unsuccessful", "error", 2000);
        }
        updateQuery();
      } catch (error) {
        showToast("Profiles Migration Unsuccessful", "error", 2000);
        console.error(error);
      }
    } catch (err) {
      showToast("Profiles Migration Unsuccessful", "error", 2000);
      console.error("Error fetching ResumeMining:", err);
    }
  };

  const capitalizeFirst = (str = "") =>
    str.charAt(0).toUpperCase() + str.slice(1);

  const fetchIntegrations = async () => {
    const integrationsPayload = {
      coll: "Integration",
      fil: JSON.stringify({
        category: { type: "NONE", value: 6 },
        type: { type: "NONE", value: 2 },
        status: { type: "NONE", value: 1 },
      }),
      ret: "uiid name",
    };
    const getIntegrations = await getAllIntegrations(integrationsPayload);

    if (getIntegrations?.success) {
      const integrationIds = getIntegrations?.data?.data?.map(
        (val) => val.uiid,
      );
      const integrationAccessPayload = {
        coll: "IntegrationAccess",
        fil: {
          integrationId: { type: "IN", value: integrationIds },
          userId: { type: "IN", value: loginUserUiid },
          status: { type: "IN", value: 1 },
        },
      };
      const getIntAccess = await getAllIntegrationAccess(
        integrationAccessPayload,
      );
      if (getIntAccess?.success) {
        setHasAiCallAccess(true);
      }
    }
  };

  useEffect(() => {
    fetchIntegrations();
  }, []);

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <div className="flex flex-col px-0 w-full flex-1 overflow-auto">
        <div className="w-full flex justify-between items-center gap-1 flex-wrap">
          <div className="flex-1 flex justify-between items-center gap-1">
            <Button // Back button
              title={
                source === 2
                  ? "Career Builder"
                  : source === 3
                    ? `${capitalizeFirst(searchQuery.searchType)} Search`
                    : "Internal DB"
              }
              color="black"
              variant="text"
              size="md"
              fromLeft
              icon="arrow_left_alt"
              className=""
              onClick={() => {
                setSearchApplicant((prev) => !prev);
              }}
            />
            <InfoCardNewAdv
              title="Total results found"
              titleConfig={{
                className: " whitespace-nowrap",
              }}
              value={getTotalRecordsCount()}
              layout="option3"
            />
          </div>
          <div className="flex justify-between items-center gap-1">
            {(source === 2 || source === 3) && (
              <div className="flex gap-3">
                {((showMailMergeForMigrated &&
                  selectMigratedProfiles.includes("1")) ||
                  (defaultExistingCandidates.length > 0 &&
                    matchedMigratedCandidates)) && (
                  <>
                    <Button
                      title="Mail Merge"
                      onClick={() => setMailMergeModalOpen(true)}
                    />
                    {hasAiCallAccess && (
                      <Button
                        title="Ai Call"
                        size="sm"
                        variant="outlined"
                        onClick={() => setIsAiCallModalOpen(true)}
                      />
                    )}
                  </>
                )}
                <Button
                  variant="outlined"
                  title="Migrate Profiles"
                  onClick={() => {
                    setMigrateProfilesModalOpen(true);
                    handleCountNoResData();
                  }}
                />
              </div>
            )}
            {(source == 2 || source == 3) && (
              <div className="p-2">
                <FormFieldSet
                  type="checkbox"
                  noTitle
                  multiple={true}
                  options={[
                    { label: "Select Only Migrated Profiles", value: "1" },
                  ]}
                  onChange={(raw) => {
                    setTableRenderKey((prev) => prev + 1);
                    const isChecked =
                      raw &&
                      typeof raw === "object" &&
                      ("target" in raw || raw.nativeEvent)
                        ? !!raw.target.checked
                        : Array.isArray(raw)
                          ? raw.length > 0
                          : typeof raw === "boolean"
                            ? raw
                            : !!raw;
                    const final = isChecked ? ["1"] : [];
                    setSelectedMigratedProfiles(final);
                    handleMigratedProfiles(final);
                  }}
                  values={selectMigratedProfiles}
                />
              </div>
            )}
          </div>
        </div>
        {/* Omkar Hide */}
        <div className="hidden">
          <div className="flex items-center justify-between gap-4 mb-2">
            <Button // Back button
              title={
                source === 2
                  ? "Career Builder"
                  : source === 3
                    ? `${capitalizeFirst(searchQuery.searchType)} Search`
                    : "Internal DB"
              }
              color="black"
              variant="text"
              size="md"
              fromLeft
              icon="arrow_left_alt"
              className=""
              onClick={() => {
                setSearchApplicant((prev) => !prev);
              }}
            />
            <InfoCardNewAdv
              title="Total results found"
              value={getTotalRecordsCount()}
              layout="option3"
            />
          </div>
          {/* //////////////////////////////TOP/////////////////////////////// */}
          {/* <div className="flex justify-end items-center"></div>
        {tableViewMode === "grid" && gridFilterMap[source] && (
          <div className="w-[400px] border-r border-gray-200 pr-4 pl-2">
            {gridFilterMap[source]}
          </div>
        )} */}
          <div className="flex justify-between items-center">
            {(source === 2 || source === 3) && (
              <div className="flex gap-3">
                {((showMailMergeForMigrated &&
                  selectMigratedProfiles.includes("1")) ||
                  (defaultExistingCandidates.length > 0 &&
                    matchedMigratedCandidates)) && (
                  <Button
                    title="Mail Merge"
                    onClick={() => setMailMergeModalOpen(true)}
                  />
                )}
                <Button
                  variant="outlined"
                  title="Migrate Profiles"
                  onClick={() => {
                    setMigrateProfilesModalOpen(true);
                    handleCountNoResData();
                  }}
                />
              </div>
            )}
            {/* {source === 3 && (
              <div className="flex gap-3">
                <Button
                  title="Mail Merge"
                  onClick={() => setMailMergeModalOpen(true)}
                />
                <Button
                  variant="outlined"
                  title="Migrate Profiles"
                  onClick={() => setMigrateProfilesModalOpen(true)}
                />
              </div>
            )} */}
          </div>
          {(source == 2 || source == 3) && (
            <div className="p-2">
              <FormFieldSet
                type="checkbox"
                noTitle
                multiple={true}
                options={[
                  { label: "Select Only Migrated Profiles", value: "1" },
                ]}
                onChange={(raw) => {
                  setTableRenderKey((prev) => prev + 1);
                  const isChecked =
                    raw &&
                    typeof raw === "object" &&
                    ("target" in raw || raw.nativeEvent)
                      ? !!raw.target.checked
                      : Array.isArray(raw)
                        ? raw.length > 0
                        : typeof raw === "boolean"
                          ? raw
                          : !!raw;
                  const final = isChecked ? ["1"] : [];
                  setSelectedMigratedProfiles(final);
                  handleMigratedProfiles(final);
                }}
                values={selectMigratedProfiles}
              />
            </div>
          )}{" "}
        </div>
        {/* Omkar Hide end */}

        <div className="inline-block bg-[#FAFAFA] text-gray-800 px-3 py-2 text-[12px] mb-2">
          {searchQuery?.payload?.query?.keywords ||
            searchQuery?.payload?.query?.Keywords ||
            searchQuery?.payload?.query?.q ||
            safeDecode(searchQuery?.payload?.query?.jt) ||
            safeDecode(searchQuery?.payload?.query?.bkeyword) ||
            searchQuery?.payload?.query?.Keywords}
        </div>

        {/* <div className="flex-1 flex min-h-[340px] "> */}
        {/* {tableViewMode === "grid" && gridFilterMap[source] && (
            <div className="w-[400px] border-r border-gray-200 pr-4 pl-2 overflow-y-auto">
              {}
            </div>
          )} */}

        <CollapsibleWrapper
          sidebarTitle="Filter Result"
          sidebar={gridFilterMap[source]}
          source={source}
        >
          <div className="flex-1 flex flex-col overflow-hidden">
            <FullScreenWrapper>
              <TableAdv
                key={`${tableRenderKey}-${tableViewMode}-${page}-${limit}`}
                showCheckbox
                rows={mappedRowSearchResults}
                columns={getTableColumns()}
                tdClassName="!py-10"
                defaultSelectedRows={defaultExistingCandidates}
                defaultView={tableViewMode}
                onSelectionChange={handleSelectionChange}
                onViewChange={setTableViewMode}
                toolbarLeft={{
                  add: [
                    {
                      component: (
                        <div className="2xl:min-w-[200px] min-w-[130px]">
                          <FormFieldSet
                            type="select"
                            size="sm"
                            noTitle
                            value={source === 3 ? monsterSort : ""}
                            placeholder={source === 2 ? "Sort by" : "Sort"}
                            options={
                              source === 2
                                ? careerbuilderOptions
                                : source === 3
                                  ? monsterSearchOptions
                                  : []
                            }
                            onChange={(value) => {
                              if (source === 2) setCareerBuilderSort(value);
                              if (source === 3) setMonsterSort(value);
                            }}
                          />
                        </div>
                      ),
                    },
                  ],
                }}
                toolbarRight={{
                  filter: false,
                  // search: true,
                  download: false,
                  viewToggle: true,
                  // fullScreen: true,
                  add:
                    source === 1
                      ? [
                          {
                            component: (
                              <div className="flex items-center gap-2">
                                <Button
                                  title="Mail Merge"
                                  size="sm"
                                  variant="outlined"
                                  onClick={() => {
                                    // if (selected.length === 0) {
                                    //   handleSelectionChange([]); // populate all
                                    // }
                                    setMailMergeModalOpen(true);
                                  }}
                                />
                                {hasAiCallAccess && (
                                  <Button
                                    title="Ai Call"
                                    size="sm"
                                    variant="outlined"
                                    onClick={() => setIsAiCallModalOpen(true)}
                                  />
                                )}
                                <Button
                                  title={"Create List"}
                                  size="sm"
                                  onClick={() => SetShowCreateListModal(true)}
                                />
                              </div>
                            ),
                          },
                        ]
                      : [],
                  order: [
                    "viewToggle",
                    "add",
                    "download",
                    "filter",
                    // "search",
                    "fullScreen",
                  ],
                  // order: ["search","add[1]", "viewToggle","add[0]", "download", "filter"],
                }}
                serverPagination={true}
                totalCount={getTotalRecordsCount()}
                page={page}
                limit={limit}
                onPaginationChange={handlePageChange}
                onLimitChange={handleLimitChangeWithReset}
                gridViewData={
                  source === 2 ? (
                    <TableGridToggleView
                      setDetailsDrawer={setDetailsDrawer}
                      source={source}
                      setCareerBuilderCurrentApplicantId={
                        setCareerBuilderCurrentApplicantId
                      }
                      gridData={mappedRowSearchResults}
                      selectedData={defaultExistingCandidates}
                      onSelectionChange={handleSelectionChange}
                    />
                  ) : source === 1 ? (
                    <TableGridToggleView
                      setDetailsDrawer={setDetailsDrawer}
                      selectedData={defaultExistingCandidates}
                      source={source}
                      setCurrentApplicantId={setCurrentApplicantId}
                      gridData={mappedRowSearchResults}
                      onSelectionChange={handleSelectionChange}
                    />
                  ) : source === 3 ? (
                    <TableGridMonsterToggleView
                      gridData={mappedRowSearchResults}
                      query={searchQuery}
                      setDetailsDrawer={setDetailsDrawer}
                      setMonsterClassicApplicantId={
                        setMonsterClassicApplicantId
                      }
                      keywords={getCurrentSearchKeywords()}
                      selected={defaultExistingCandidates}
                      onSelectionChange={handleSelectionChange}
                      source={source}
                    />
                  ) : null
                }
              />
            </FullScreenWrapper>
          </div>
        </CollapsibleWrapper>
      </div>
      {/* </div> */}

      <DetailsDrawer
        isOpen={detailsDrawer}
        onClose={() => setDetailsDrawer(false)}
        source={source}
        searchQuery={searchQuery}
        getCurrentApplicantPersonalDetails={getCurrentApplicantPersonalDetails}
        getCurrentApplicantJobTitle={getCurrentApplicantJobTitle}
        getCurrentApplicantContactDetailsForHeader={
          getCurrentApplicantContactDetailsForHeader
        }
        candidate={getCandidateFullDetailsForResume}
        keywords={getCurrentSearchKeywords}
        loading={loading}
      />

      <Backdrop isOpen={loading} zIndex={53}>
        <LogoLoader />
      </Backdrop>
      <CreateListModal
        showCreateListModal={showCreateListModal}
        SetShowCreateListModal={SetShowCreateListModal}
      />

      <MailMergeModal
        mailMergeModalOpen={mailMergeModalOpen}
        setMailMergeModalOpen={setMailMergeModalOpen}
        filteredMonsterMailMergeData={mailMergeCandidates}
        handleDelete={handleDelete}
        selectedData={selected}
        source={source}
        searchQuery={query}
        //candidatesData={mailMergeCandidates}
      />

      <MigrateProfilesModal
        migrateProfilesModalOpen={migrateProfilesModalOpen}
        setMigrateProfilesModalOpen={setMigrateProfilesModalOpen}
        filteredMonsterMailMergeData={filteredMonsterMailMergeData}
        handleonClick={() =>
          source === 2 ? fetchCBSubmissions() : fetchSubmissions()
        }
        noResCandidateslength={noResCandidates}
      />
      <AddNoteModal
        isOpen={noteModal}
        onClose={() => setNotesModal(false)}
        data={getCandidateFullDetailsForResume()}
        // source={"jobBoards"}
        source={source}
      />

      <AiCallModel
        isOpen={isAiCallModalOpen}
        onClose={() => setIsAiCallModalOpen(false)}
        searchQuery={query}
        source={source}
        // selectedApplicants={mailMergeCandidates}
        selectedApplicants={[
          ...new Map(
            mailMergeCandidates.map((applicant) => [
              applicant.applicantId,
              applicant,
            ]),
          ).values(),
        ]}
      />
    </div>
  );
};

export default SearchResults;
